module.exports = __webpack_public_path__ + "static/img/miniProgramCode1.7ba6cb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/config/miniProgramCode1.jpg
// module id = qFCN
// module chunks = 3